/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Location_IdInputs */



/**
* | output |
* | --- |
* | "Location ID" |
*
* @param {Explorer_Info_Property_Location_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_location_id = /** @type {((inputs?: Explorer_Info_Property_Location_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Location_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID d'emplacement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standort-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор местоположения")
	if (locale === "es") return /** @type {LocalizedString} */ ("ID de ubicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("場所ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थान आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID de localização")
	return /** @type {LocalizedString} */ ("Location ID")
});